import { apiZodios } from '~api/apiZodios'
import { type IdentityId, type UserId } from '~types'

interface ContactRouteByIdentityResponse {
  contact_book_code: string | null
  contact_handle: string | null
}

export const resolveContactRouteByIdentity = async (
  userId: UserId,
  organizationIdentityId: IdentityId,
  identityId: IdentityId,
): Promise<string | null> => {
  const response = await apiZodios.axios.post<ContactRouteByIdentityResponse>(
    '/contacts/get-contact-route-by-identity/',
    {
      user_id: userId,
      organization_identity_id: organizationIdentityId,
      identity_id: identityId,
    },
  )

  const contactBookCode = response.data.contact_book_code
  const contactHandle = response.data.contact_handle

  if (!contactBookCode || !contactHandle) {
    return null
  }

  return `/contacts/${contactBookCode}/${contactHandle}`
}
